import React, { useCallback, useState } from 'react';
import { useLeadByIdQuery } from 'api';
import { useParams } from 'react-router-dom';
import { Button, Col, Row } from 'components';
import { OriginalEmailModal } from 'components';
import { GreenEmailIcon } from 'components/common/icons/GreenEmailIcon';
import styles from '../styles.module.scss';

export const OriginalEmailLink = React.memo(() => {
  const [openEmail, setOpenEmail] = useState(false);
  const { id } = useParams() as { id: string };
  const { data: leadDetails = {} } = useLeadByIdQuery({ id });

  const onModalStateChange = useCallback(() => {
    setOpenEmail((oState) => !oState);
  }, []);

  if (!leadDetails.emailId) {
    return null;
  }
  return (
    <Row>
      <Col span={22} className={styles.open_email}>
        <Button onClick={onModalStateChange} className={styles.text} type={'link'} icon={<GreenEmailIcon />}>
          Client Original Email
        </Button>
      </Col>
      <OriginalEmailModal emailId={leadDetails.emailId} isModalOpen={openEmail} onClose={onModalStateChange} />
    </Row>
  );
});
